// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Теги» (Tags, ключ `tag`, група `basic`). */
export const tagsManifest: IModuleManifest = {
  key: 'tag',
  group: 'basic',
  slug: 'tags',
  prefix: 'TAG',
  name: { en: 'Tags', uk: 'Теги' },
  entities: [
    { key: 'tag', slug: 'tag', name: { en: 'Tags', uk: 'Теги' }, main: true },
    { key: 'tag_tagged_record', slug: 'tag-tagged-record', name: { en: 'Tag Tagged Records', uk: 'Позначені записи' }, main: false },
    { key: 'tag_group', slug: 'tag-group', name: { en: 'Tag Groups', uk: 'Групи' }, main: false },
  ],
  loadState: () => import('./state/tagsSlice').then((m) => m.tagsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
